import React from "react";
import { Title, } from "../../ReUableComponents/CommonElements";
import { Row, Col } from "react-bootstrap";
import MOU1 from "../../Assessts/Images/Gallery/Photo/MOU1.png";
import MOU2 from "../../Assessts/Images/Gallery/Photo/MOU2.png";
import MOU3 from "../../Assessts/Images/Gallery/Photo/MOU3.png";
import MOU4 from "../../Assessts/Images/Gallery/Photo/MOU4.png";

import NSF1 from "../../Assessts/Images/Gallery/Photo/NSF1.png";
import NSF2 from "../../Assessts/Images/Gallery/Photo/NSF2.png";
import NSF3 from "../../Assessts/Images/Gallery/Photo/NSF3.png";

import GE1 from "../../Assessts/Images/Gallery/Photo/GE1.png";
import GE2 from "../../Assessts/Images/Gallery/Photo/GE2.png";
import GE3 from "../../Assessts/Images/Gallery/Photo/GE3.png";

import TGMREIS1 from "../../Assessts/Images/Gallery/Photo/TGMREIS1.png";
import TGMREIS2 from "../../Assessts/Images/Gallery/Photo/TGMREIS2.png";

import APKGBV1 from "../../Assessts/Images/Gallery/Photo/APKGBV1.png";
import APKGBV2 from "../../Assessts/Images/Gallery/Photo/APKGBV2.png";
import APKGBV3 from "../../Assessts/Images/Gallery/Photo/APKGBV3.png";

import NATCO1 from "../../Assessts/Images/Gallery/Photo/NATCO1.png";
import NATCO2 from "../../Assessts/Images/Gallery/Photo/NATCO2.png";
const PhotoGallery = () => {

    const Data = [
        { Tittle: "NSF Team", Images: [NSF1, NSF2, NSF3] },
        { Tittle: "Global Edge Students participating in Pilot Assessment", Images: [GE1, GE2, GE3], },
        { Tittle: "TGMREIS Students participating in Pilot Assessment", Images: [TGMREIS1, TGMREIS2], },
        { Tittle: "APKGBV students attending NSF’s Competency-Based Assessments", Images: [APKGBV1, APKGBV2, APKGBV3], },
        { Tittle: "Students from NATCO-supported schools participated in NSF’s assessments", Images: [NATCO1, NATCO2], },
    ];

    return (<div className="PGallery-Maindiv">
        <div className="Web-MainHeading">Photo Gallery</div>

        <Title Title="MOU" className="Web-SubHeading" />
        <div className="container-fluid mt-3">
            <Row className="dflex gap-2">
                <Col className="dflex flexd-column alignitems">
                    <img src={MOU1} alt="MOU1" />
                    MOU Signed between NSF and Samagra Siksha Abhiyan
                </Col>
                <Col className="dflex flexd-column alignitems">
                    <img src={MOU2} alt="MOU2" />
                    MOU Signed between NSF and NATCO{" "}
                </Col>
                <Col className="dflex flexd-column alignitems">
                    <img src={MOU3} alt="MOU3" />
                    MOU Signed between NSF and Diksha Foundation (Bihar)
                </Col>
                <Col className="dflex flexd-column alignitems">
                    <img src={MOU4} alt="MOU4" />
                    MOU Signed between NSF and Viswam Edutech{" "}
                </Col>
            </Row>
        </div>

        {Data.map((item) => (
            <>
                <Title Title={item.Tittle} className="Web-SubHeading" />
                <div className="container-fluid mt-3">
                    <Row className="dflex gap-2">
                        {item.Images.map((item) => (
                            <Col className="dflex flexd-column alignitems">
                                <img src={item} alt={`${item}`} className="p-0" />
                            </Col>
                        ))}
                    </Row>
                </div>
            </>
        ))}

    </div>)
}
export default PhotoGallery;